import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { NavLink, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  MANAGE_POI_EDIT_PATH,
  MANAGE_POI_INTERNAL_LINKS_PATH,
  MANAGE_POI_EXTERNAL_LINKS_PATH,
  MANAGE_POI_PHOTOS_PATH,
  MANAGE_BEFORE_AFTERS_PATH,
} from '../../config/routes'

const ManagePoiNavBar = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  return (
    <Navbar
      className="standard-background navbar-dark-text"
      style={{ marginTop: '10px' }}
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <NavLink
            to={MANAGE_POI_EDIT_PATH.replace(':id', id)}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('EDIT')}
          </NavLink>

          <NavLink
            to={MANAGE_POI_INTERNAL_LINKS_PATH.replace(':id', id)}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_INTERNAL_LINKS')}
          </NavLink>

          <NavLink
            to={MANAGE_POI_EXTERNAL_LINKS_PATH.replace(':id', id)}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_EXTERNAL_LINKS')}
          </NavLink>

          <NavLink
            to={MANAGE_POI_PHOTOS_PATH.replace(':id', id)}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_PHOTOS')}
          </NavLink>

          <NavLink
            to={MANAGE_BEFORE_AFTERS_PATH.replace(':id', id)}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('MANAGE_BEFORE_AFTERS')}
          </NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default ManagePoiNavBar
